import LegalPage from './LegalPage';

export default function TermsOfServicePage() {
  return (
    <LegalPage
      title="서비스 이용약관"
      mdPath="/legal/terms-of-service.md"
    />
  );
}
